import commonCard from '@assets/css/common-card.css';

/**
 * Reports card styles.
 * @type {CSSStyleSheet}
 */
export const commonCardStyles = new CSSStyleSheet();
commonCardStyles.replaceSync(commonCard);
